<template>
	<food :classfy="classfy"></food>
	
</template>

<script>
	import food from './management/food.vue'
	export default {
		data() {
			return {
				classfy: ''
			}
		},
		mounted() {
			this.initClassfy();
		},
		watch:{
			'$route'(){
				this.initClassfy();
			}
		},
		components:{
			food
		},
		methods: {
			initClassfy(){
				this.classfy = this.$route.params.id;
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
